var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-my-layout',[_c('div',{attrs:{"slot":"body"},slot:"body"},[_vm._v("\n    "+_vm._s(_vm.$t("general.resetPassword.placeholder"))+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }